import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import RecaptchaContextProvider from '@/common/contexts/RecaptchaContext';
import withLoginLogic from '@/common/hoc/withLoginLogic';
import PageLoader from '@/ebat/components/blocks/PageLoader/PageLoader';

import Login from './Login';
import {
  LoginContainerDefaultProps,
  LoginContainerPropTypes,
} from './Login.proptypes';
import useLoginContainer from './useLogin.container';

const LoginContainer = ({
  errors, // withLoginLogic
  onSubmit, // withLoginLogic
  paramIsOpen, // withLoginLogic
}) => {
  const { t } = useTranslation();

  const { company, isDisabled, warehouse } = useLoginContainer();

  if (isDisabled.loading) {
    return <PageLoader className="scanbat-login-page" />;
  }

  return (
    <>
      <Helmet>
        <title>
          {`${t(
            `ebat:entities:scanbat.${
              paramIsOpen ? 'forgot_password' : 'login'
            }.title`,
          )} - ${t('ebat:messages:scanbat.title')}`}
        </title>
      </Helmet>
      <main className="main scanbat-login-page">
        <RecaptchaContextProvider>
          <Login
            company={company}
            disabled={isDisabled.disabled}
            errors={errors}
            onSubmit={onSubmit}
            paramIsOpen={paramIsOpen}
            warehouse={warehouse}
          />
        </RecaptchaContextProvider>
      </main>
    </>
  );
};

LoginContainer.defaultProps = {
  ...LoginContainerDefaultProps,
};

LoginContainer.propTypes = {
  ...LoginContainerPropTypes,
};

export default withLoginLogic(LoginContainer);
